<template>
    <div class="container-fluid">
        <div class="titlle_div">
            <h5 class="title">Submotivos</h5>
        </div>
        <emt-form ref="subreason-form" v-bind:resource="config.api + '/subreason/'" v-bind:items="itemsForm" v-on:register="reload" v-bind:updateData="update"></emt-form>
        <emt-grid ref="subreason-grid" v-bind:resource="config.api + '/subreason_full_data/'" v-bind:items="itemsGrid" v-bind:edit="editUrl" v-bind:deleteUrl="deleteUrl"></emt-grid>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import router from '@/router'
import generic from '@/generic'
import Config from '@/config'
import EmtForm from '@/components/emt-form'
import EmtLoading from '@/components/emt-loading'
import EmtTable from '@/components/emt-grid'

export default{
    name: 'emt-form-subreason',
    data: function () {
        return {
            itemsForm: [
                {
                    'name': 'name',
                    'label': 'Submotivo',
                    'placeholder': 'Ingrese submotivo',
                    'value': null,
                    'maxlength': '50',
                    'type': 'text',
                    'errors': []
                }, {
                    'name': 'reason',
                    'label': 'Motivo',
                    'placeholder': 'Seleccione un motivo',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': []
                }
            ],
            itemsGrid: [
                {
                    'name': 'name',
                    'label': 'Submotivo',
                    'ordering': true,
                    'filters': ['exact', {
                        'name': 'icontains',
                        'label': 'Puede contener'
                    }]
                }, {
                    'name': {
                        'object': 'reason',
                        'key': 'name'
                    },
                    'label': 'Motivo',
                    'ordering': true,
                    'filters': ['exact', {
                        'name': 'icontains',
                        'label': 'Puede contener'
                    }]
                }, {
                    'name': 'is_active',
                    'label': 'Estado',
                    'value': null,
                    'ordering': true
                }
            ],
            config: Config,
            update: false,
            editUrl: '/subreason/',
            deleteUrl: Config.api + '/subreason/'
        }
    },
    methods: {
        reload: function () {
            this.$refs['subreason-grid'].reload()
        },
        /*
        *esta funcion permite consultar y listar las unidades
        */
        getReason: function () {
            var self = this
            self.$http.get(Config.api + '/reason/?nopaginate=1&is_active=true&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsForm[1].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    })
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
        }
    },
    created: function () {
        if (!Cookies.get('token')) {
            router.push('/login')
            return
        }
        generic.setToken()
        this.getReason()
    },
    components: {
        'emt-form': EmtForm,
        'emt-loading': EmtLoading,
        'emt-grid': EmtTable
    }
}
</script>



// WEBPACK FOOTER //
// emt-form-subreason.vue?12102d7d